export const APPEARANCES = {
  default: 'default',
  accent: 'accent',
  cta: 'cta',
  danger: 'danger',
  success: 'success',
  warning: 'warning',
  info: 'info',
};

export const ALIGN = {
  left: 'left',
  center: 'center',
  stretch: 'stretch',
};
